export default {
    // 分页获取state列表
    getStatePage: "/state/getStatePage",
    // 新增state
    saveState: "/state/saveState",
    // 根据id修改state
    updateState: "/state/updateState",
    // 根据ids删除state
    delState: "/state/delState",
   // state 字典表
    getStateDictByProperty:"/state/getStateDict",
    // 根据id修改state状态
    updateStateStatus: "/state/updateStateStatus",
    // county===================================
    // 分页获取county 列表    
    getCountyPage: "/county/getCountyPage",
    // 新增county
    saveCounty: "/county/saveCounty",
    // 根据id修改county
    updateCounty: "/county/updateCounty",
    // 批量删除county
    delCounty: "/county/delCounty",
    // stata字典表(关联state id)
    getCountyStateDict: "/county/getStateDict",
   // 查询county字典
    getCountyDictByProperty:'/county/getAllCountyDictForName',
    // 根据stateID 关联county
    getCountyDictForId:"/county/getCountyDictForId",
    // 根据id修改county状态
    updateCountyStatus: "/county/updateCountyStatus",

    // city===================================
    // 分页获取city 列表    
    getCityPage: "/city/getCityPage",
    // 新增city
    saveCity: "/city/saveCity",
    // 根据id修改city
    updateCity: "/city/updateCity",
    // 批量删除city
    delCity: "/city/delCity",
    // 获取county字典
    getCountyDict: "/city/getCountyDict",
      // 查询city字典
    getCityDictByProperty:"/city/getAllCityDict",
    getCityDictByState:"/city/getCityDictByState",
        // 根据countyID 获取City值
    getCityDictForId:"/city/getCityDictForId",
    // 根据id修改city状态
    updateCityStatus: "/city/updateCityStatus",
}   
